var dropdownSeparator = 'separator_dropdownSeparator__cwygty0';

export { dropdownSeparator };
//# sourceMappingURL=separator.vanilla.mjs.map
